import { render, staticRenderFns } from "./SmallClaims.vue?vue&type=template&id=e21d836e&"
import script from "./SmallClaims.vue?vue&type=script&lang=js&"
export * from "./SmallClaims.vue?vue&type=script&lang=js&"
import style0 from "./SmallClaims.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports